import { useState } from "react";
import { Link } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { AuthShell } from "@/pages/Login";
import { CaptchaField, useCaptcha } from "@/components/Captcha";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [err, setErr] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const { captcha, setCaptcha, reload, fields } = useCaptcha();

  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setErr("");
    try { await api.post("/auth/forgot-password", { email, ...fields }); setSent(true); }
    catch (e2) { setErr(errMsg(e2)); reload(); } finally { setBusy(false); }
  };

  return (
    <AuthShell title="Mot de passe oublié" subtitle="Nous vous enverrons un lien à usage unique, valable 1 heure." footer={<Link to="/login" className="text-amber-400 hover:underline" data-testid="goto-login-link">Retour à la connexion</Link>}>
      {sent ? (
        <div className="panel p-5 text-sm text-zinc-300" data-testid="forgot-success">
          Si un compte existe pour <span className="font-mono text-amber-400">{email}</span>, un e-mail de réinitialisation vient d'être envoyé. Pensez à vérifier vos spams.
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5"><Label>Email du compte</Label><Input type="email" required maxLength={254} value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" /></div>
          <CaptchaField captcha={captcha} setCaptcha={setCaptcha} reload={reload} prefix="forgot" />
          {err && <p className="text-sm text-red-400" data-testid="forgot-error">{err}</p>}
          <Button type="submit" disabled={busy} className="w-full bg-amber-500 hover:bg-amber-400 text-zinc-950 font-semibold" data-testid="forgot-submit-button">{busy ? "Envoi…" : "Envoyer le lien"}</Button>
        </form>
      )}
    </AuthShell>
  );
}
